module.exports = __webpack_public_path__ + "img/app_eclipse.749e62d8.png";